// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1lPdB","buttons":"PendingPaymentAlert_buttons__23zPv"};